import React from "react";
import PomotoneClock from "./components/PomotoneClock";
import "./style.css";

const App = () => (
  <div className="app-container">
    {/* Background + overlay */}
    <div className="background-wrapper">
      <img
        src="/assets/images/background_office.png"
        alt="Office Background"
        className="background-image"
      />
      <img
        src="/assets/images/overlay.png"
        alt="Intro Overlay"
        className="intro-overlay"
      />
    </div>

    {/* Clock on the right */}
    <div className="clock-wrapper">
      <PomotoneClock />
    </div>
  </div>
);

export default App;